export const defaults = {
  new_password: '',
  new_password_repeat: '',
  current_password: ''
}

const passwordRegex = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[@$!%^*?&])/

export const rules = {
  new_password: [
    'required',
    'min:10',
    `regex:${passwordRegex}`
  ],
  new_password_repeat: 'same:new_password',
  current_password: 'required'
}

export const customErrorMessages = {
  required: 'This filed is required',
  same: 'Passwords should match',
  regex: 'Password should contain at least 1 number, 1 letter and 1 special character'
}
